import {
  getHierarchyPayments,
  postHierarchyPayment,
  putHierarchyPayment,
} from '../../../Api/services/backoffice';

export const key = 'hierarchyPayment';

const entityName = {
  singular: 'Alçada de Aprovação de Pagamento',
  plural: 'Alçadas de Aprovação de Pagamento',
};

const queries = {
  list: { key, fn: getHierarchyPayments },
  detail: { key },
};

const mutations = {
  create: postHierarchyPayment,
  update: putHierarchyPayment,
};

const fields = {
  table: [
    { key: 'approvalAuthority.approver', label: 'Hierarquia' },
    { key: 'rule', label: 'Descrição' },
    { key: 'volumeMin', label: 'Volume de traços Mínimo (m³)' },
    { key: 'volumeMax', label: 'Volume de traços Máximo (m³)' },
    { key: 'daysMin', label: 'Prazo de pagamento mínimo (dias)' },
    { key: 'daysMax', label: 'Prazo de pagamento máximo (dias)' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
